import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import LandingLayout from './LandingLayout';
import { useI18n } from '../../i18n/LanguageContext';
import { landingCopy } from './copy';
import { resolveLandingContext } from './regional';
import { buildLandingV2Content } from './v2/content';
import { useLandingV2Motion } from './v2/useLandingV2Motion';
import { Hero } from './v2/Hero';
import { Marquee } from './v2/Marquee';
import { Shift } from './v2/Shift';
import { Pillars } from './v2/Pillars';
import { Scribe } from './v2/Scribe';
import { Proof } from './v2/Proof';
import { Founding } from './v2/Founding';
import { Capabilities } from './v2/Capabilities';
import { Finale } from './v2/Finale';
import './v2/v2-base.css';
import './v2/v2-sections.css';

export default function LandingPage() {
  const location = useLocation();
  const { language } = useI18n();
  const { locale, market } = resolveLandingContext(location.pathname, language);
  const content = buildLandingV2Content(landingCopy[locale].platform, locale, market);
  const rootRef = useRef<HTMLDivElement>(null);

  useLandingV2Motion(rootRef);

  return (
    <LandingLayout pageKey="platform">
      <div className="landing-v2" ref={rootRef}>
        <Hero content={content.hero} />
        <Marquee items={content.marquee} />
        <Shift content={content.shift} />
        <Pillars content={content.pillars} />
        <Scribe content={content.scribe} />
        <Proof content={content.proof} />
        <Founding content={content.founding} />
        <Capabilities content={content.capabilities} />
        <Finale content={content.finale} />
      </div>
    </LandingLayout>
  );
}
